// Rollback da tela "Desenvolvimento" sem mexer em código: build com REACT_APP_DEV_SCREEN=0 esconde o menu e a rota.
// Qualquer outro valor (ou ausente) mantém a tela ligada.
export const devScreenEnabled = (env = process.env) => env.REACT_APP_DEV_SCREEN !== '0';
